// De testfase van een winkel, gezien vanuit de widget. (Mollie blok 2, 15-09-2026.)
//
// Een nieuwe winkel staat al klaar terwijl Mollie nog loopt. Gasten zien dan "Binnenkort
// beschikbaar": de api antwoordt 423 met code "binnenkort". De eigenaar opent zijn widget of webshop
// met een voorbeeldlink (?voorbeeld=...); dat teken gaat bij elke aanvraag mee in de kop
// X-Jimani-Voorbeeld. Laat de api hem daardoor door, dan zet hij X-Jimani-Testmodus in het antwoord en
// staat bovenin de balk "Testmodus - nog niet live". Alleen dan: met een oud teken in een winkel die
// al live is, is er geen balk.
//
// Het teken wordt ook in sessionStorage bewaard. Na een testbetaling komt de eigenaar via Mollie terug
// op de widget, en dat adres heeft het teken niet meer; zonder bewaren zou hij na het betalen ineens
// "Binnenkort beschikbaar" zien.

export const KOP = 'X-Jimani-Voorbeeld';
export const TESTMODUS_KOP = 'x-jimani-testmodus';
const OPSLAG = 'jimani-voorbeeld';

let teken = null;
let binnenkort = false;
let dicht = false;
let testmodus = false;
const luisteraars = new Set();

function opslag() {
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
}

/** Leest het teken uit het adres, anders uit wat eerder in deze sessie is bewaard. */
export function startTestmodus(zoek = window.location.search, bewaarplek = opslag()) {
    let uitAdres = null;

    try {
        uitAdres = new URLSearchParams(zoek || '').get('voorbeeld');
    } catch {
        uitAdres = null;
    }

    if (uitAdres) {
        teken = uitAdres;
        try { bewaarplek?.setItem(OPSLAG, uitAdres); } catch { /* geen opslag: alleen deze pagina */ }
    } else {
        try { teken = bewaarplek?.getItem(OPSLAG) || null; } catch { teken = null; }
    }

    return teken;
}

export const voorbeeldTeken = () => teken;

export const isBinnenkort = () => binnenkort;

export const isTestmodus = () => testmodus;

/** De zaak is (tijdelijk) dicht voor gasten: in de admin gedeactiveerd, of de betaalde modules staan op pauze. (12-10-2026) */
export const isDicht = () => dicht;

const seinOp = () => luisteraars.forEach((luisteraar) => luisteraar());

export function meldBinnenkort() {
    if (binnenkort) return;
    binnenkort = true;
    seinOp();
}

export function meldDicht() {
    if (dicht) return;
    dicht = true;
    seinOp();
}

export function meldTestmodus() {
    if (testmodus) return;
    testmodus = true;
    seinOp();
}

/** Voor useSyncExternalStore: sein bij elke verandering van binnenkort, dicht of testmodus. */
export function volgBinnenkort(luisteraar) {
    luisteraars.add(luisteraar);
    return () => luisteraars.delete(luisteraar);
}

/** Is dit antwoord de testfasepoort die zegt: deze winkel is nog dicht? */
export const isBinnenkortAntwoord = (antwoord) =>
    antwoord?.status === 423 && antwoord?.data?.code === 'binnenkort';

/**
 * Is dit antwoord de poort die zegt: deze zaak is tijdelijk dicht? Code niet-beschikbaar (in de admin gedeactiveerd,
 * Martijn 12-10-2026) of pauze (14 dagen onbetaald; die code toonde de widget tot dan niet en liep vast).
 */
export const isDichtAntwoord = (antwoord) =>
    antwoord?.status === 423 && ['niet-beschikbaar', 'pauze'].includes(antwoord?.data?.code);

/** Het teken mee bij elke aanvraag, en een "binnenkort" van de api omzetten in het scherm. */
export function koppelAanAxios(client) {
    client.interceptors.request.use((config) => {
        if (teken) {
            config.headers = config.headers || {};
            if (typeof config.headers.set === 'function') config.headers.set(KOP, teken);
            else config.headers[KOP] = teken;
        }
        return config;
    });

    client.interceptors.response.use(
        (antwoord) => {
            const kop = antwoord?.headers?.[TESTMODUS_KOP]
                ?? (typeof antwoord?.headers?.get === 'function' ? antwoord.headers.get(TESTMODUS_KOP) : undefined);
            if (teken && kop === '1') meldTestmodus();
            return antwoord;
        },
        (fout) => {
            if (isBinnenkortAntwoord(fout?.response)) meldBinnenkort();
            else if (isDichtAntwoord(fout?.response)) meldDicht();
            return Promise.reject(fout);
        }
    );
}

// Alleen voor de proeven: de toestand terug naar begin.
export function _herstel() {
    teken = null;
    binnenkort = false;
    dicht = false;
    testmodus = false;
    luisteraars.clear();
}
